export default __webpack_public_path__ + "static/runtask2-278078f1da44f132d5f15cd725dfcd41.png";